import { render } from "./dialogTable.vue?vue&type=template&id=c2eeb888&scoped=true"
import script from "./dialogTable.vue?vue&type=script&lang=js"
export * from "./dialogTable.vue?vue&type=script&lang=js"

import "./dialogTable.vue?vue&type=style&index=0&id=c2eeb888&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2eeb888"]])

export default __exports__